import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTimeout from 'react-timeout';
import classNames from 'classnames';
import { noop } from 'helpers/GlobalHelper';
import Style from './CountdownText.module.scss';

class CountdownText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      duration: props.duration,
    };
  }

  componentDidMount() {
    this.startCountdown();
  }

  formatDuration = duration => {
    const sec = duration % 60;
    const seconds = sec < 10 ? `0${sec}` : sec;
    const minutes = Math.floor(duration / 60);
    return `${minutes}:${seconds}`;
  };

  startCountdown() {
    const { clearInterval, setInterval, onCountdownEnd } = this.props;
    setInterval(() => {
      const { duration } = this.state;
      if (duration <= 0) {
        onCountdownEnd();
        clearInterval();
      } else {
        this.setState({ duration: duration - 1 });
      }
    }, 1000);
  }

  render() {
    const { prefix, isVideoContainer } = this.props;
    const { duration } = this.state;
    const timeLeft = this.formatDuration(duration);
    return (
      <div
        className={classNames([
          Style.countdownTime,
          isVideoContainer && Style.countdownVideoContainer,
        ])}
      >
        {prefix}
        {timeLeft}
      </div>
    );
  }
}

CountdownText.defaultProps = {
  isVideoContainer: false,
  onCountdownEnd: noop,
  prefix: null,
};

CountdownText.propTypes = {
  clearInterval: PropTypes.func.isRequired,
  duration: PropTypes.number.isRequired,
  isVideoContainer: PropTypes.bool,
  onCountdownEnd: PropTypes.func,
  prefix: PropTypes.string,
  setInterval: PropTypes.func.isRequired,
};

const TimeoutCountdownText = ReactTimeout(CountdownText);

export default TimeoutCountdownText;
